import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = { class: "main-content" }
const _hoisted_4 = { class: "content-wrapper" }
const _hoisted_5 = { class: "row-value" }
const _hoisted_6 = { class: "actions" }
const _hoisted_7 = { class: "row-price" }
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "section-content"
}
const _hoisted_10 = { class: "row-value" }
const _hoisted_11 = { class: "actions" }
const _hoisted_12 = { class: "row-price" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["section-row with-image", { mobile: $props.isMobile }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString($props.title), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        ($setup.isUpgradeSection && $props.value)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($props.value, (upgrade, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "section-content",
                key: upgrade._id
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(upgrade.name), 1),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString($setup.formatPrice(upgrade.price)), 1),
                  ($props.isMobile)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "expand-button",
                        onClick: $setup.toggleExpand
                      }, [
                        _createElementVNode("img", {
                          class: _normalizeClass(["arrow", { 'arrow--up': $setup.isExpanded }]),
                          src: $setup.ArrowUpLanding,
                          alt: "Expand arrow"
                        }, null, 10, _hoisted_8)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString($props.value || "-"), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString($setup.formatPrice($props.price)), 1),
                ($props.isMobile)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "expand-button",
                      onClick: $setup.toggleExpand
                    }, [
                      _createElementVNode("img", {
                        class: _normalizeClass(["arrow", { 'arrow--up': $setup.isExpanded }]),
                        src: $setup.ArrowUpLanding,
                        alt: "Expand arrow"
                      }, null, 10, _hoisted_13)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
      ])
    ]),
    ($props.imageUrl && ($props.isMobile ? $setup.isExpanded : true))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["section-image-wrapper", { 'is-expanded': $setup.isExpanded && $props.isMobile }])
        }, [
          _createElementVNode("img", {
            class: _normalizeClass(["section-image", { floorplan: $setup.isFloorplan }]),
            src: $props.imageUrl,
            alt: $props.title.toLowerCase()
          }, null, 10, _hoisted_14)
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}